
(function() {
	// mobile 
	const openInquiryMobileBtn = document.getElementById("inquiry--mobile");

	openInquiryMobileBtn.addEventListener("click", () => {
		const inquiryForm = document.querySelector('.inquiry-form');
		inquiryForm.classList.toggle('hide');
	});

	// desktop 
	const openInquiryDesktopBtn = document.getElementById("inquiry--desktop");
	const overlay = document.getElementById("modalOverlay");
	const dialog = document.getElementById("modal");
	const closeBtn = document.getElementById("closeModalBtn");

	// Keep track of the element that opened the modal so we can restore focus.
	let lastFocusedElement = null;

    // Focus trap: keep tab focus inside the dialog while open.
	function getFocusableElements(container) {
	const selectors = [
		"a[href]",
		"button:not([disabled])",
		"input:not([disabled]):not([type='hidden'])",
		"select:not([disabled])",
		"textarea:not([disabled])",
		"[tabindex]:not([tabindex='-1'])"
	];

	return Array.from(container.querySelectorAll(selectors.join(",")))
		.filter(el => {
			// Exclude anything explicitly hidden
			if (el.hasAttribute("hidden")) return false;
			if (el.getAttribute("aria-hidden") === "true") return false;

			const style = window.getComputedStyle(el);
			if (style.display === "none" || style.visibility === "hidden") {
				return false;
			}

			// Exclude hCaptcha (and similar embedded infra)
			if (
				el.closest(".h-captcha") ||
				el.closest("[data-hcaptcha-widget-id]")
			) {
				return false;
			}

			return true;
		});
	}

	function openModal() {
		lastFocusedElement = document.activeElement;

		overlay.classList.remove("hide");
		overlay.setAttribute("aria-hidden", "false");

		// Prevent background scroll
		document.body.style.overflow = "hidden";

		const focusables = getFocusableElements(dialog);
		(focusables[0] || dialog).focus();

		document.addEventListener("keydown", onKeyDown);
		document.addEventListener("keydown", trapFocus);
	}

	function onKeyDown(e) {
		if (e.key === "Escape") {
			e.preventDefault();
			closeModal();
		}
	}

	function closeModal() {
		  overlay.classList.add("hide");
      overlay.setAttribute("aria-hidden", "true");

      document.body.style.overflow = "";

      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("keydown", trapFocus);

	   // Restore focus to opener
      if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
        lastFocusedElement.focus();
      }
	}


	function trapFocus(e) {
		if (e.key !== "Tab") return;

		const focusables = getFocusableElements(dialog);
		if (focusables.length === 0) return;

		const first = focusables[0];
		const last = focusables[focusables.length - 1];

		// If Shift+Tab on first, wrap to last
		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		}
		// If Tab on last, wrap to first
		else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	}

	openInquiryDesktopBtn.addEventListener("click", openModal);
	closeBtn.addEventListener("click", closeModal);

	overlay.addEventListener("click", (e) => {
		if (e.target === overlay) closeModal();
	});
})();
